import React, { useEffect, useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { LanguageContext } from '../../contexts/LanguageContext';
import { 
  StyledProblem, 
  ProblemGrid, 
  ProblemCard, 
  TechBackground, 
  TechGrid 
} from './styles';

const Problem = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  const problems = [
    {
      icon: 'fas fa-clock',
      title: 'wastedTime',
      description: 'wastedTimeDesc'
    },
    {
      icon: 'fas fa-exclamation-triangle',
      title: 'lostDeadlines',
      description: 'lostDeadlinesDesc'
    },
    {
      icon: 'fas fa-file-alt',
      title: 'bureaucracy',
      description: 'bureaucracyDesc'
    }
  ];

  // Adicionar efeito de movimento para a grade tecnológica
  useEffect(() => {
    const techGrid = document.querySelector('.tech-grid');

    const handleMouseMove = (e) => {
      if (!techGrid) return;
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;

      techGrid.style.transform = `perspective(500px) rotateX(${60 + y * 5}deg) rotateY(${x * 5}deg)`;
    };

    if (techGrid) {
      document.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <StyledProblem id="problema">
      <div className="container">
        <h2 dangerouslySetInnerHTML={{ __html: translations[language].problemTitle }} />
        <ProblemGrid>
          {problems.map((problem, index) => (
            <ProblemCard 
              key={index} 
              data-aos="fade-right" 
               data-aos-delay={index * 50}
            >
              <div className="icon">
                <i className={problem.icon}></i>
              </div>
              <h3>{translations[language][problem.title]}</h3>
              <p>{translations[language][problem.description]}</p>
            </ProblemCard>
          ))}
        </ProblemGrid>
      </div>
      <TechBackground>
        <TechGrid className="tech-grid" />
      </TechBackground>
    </StyledProblem>
  );
};

export default Problem;
